import React from "react";
import { pxToRem, toNumberFixed } from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Skeleton, Image } from "antd-mobile";
import { DownFill } from "antd-mobile-icons";
import useCenterPopup from "@/hooks/useCenterPopup";
import ApplyProportion from "@/pages/Mine/comp/ApplyProportion";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const VaultBalance: React.FC<{ data: Record<string, any> }> = ({ data }) => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const ApplyProportionPopup = useCenterPopup();
	const { isAdminType } = useSelector((state: RootState) => state.auth);

	return (
		<div className={`${useClasses.cardWrap} ${classes.vaultBalance}`}>
			<div className="up">
				<div className="vaultScale">
					<div>{t("VaultBalance")}</div>
					{!isEmpty(data) ? (
						<strong>{toNumberFixed(data.balance, 2)}</strong>
					) : (
						<Skeleton
							animated
							style={{ height: pxToRem(40), width: "80%" }}
						/>
					)}
				</div>
				<div className="vaultScale">
					<div>{t("Scale")}</div>
					{!isEmpty(data) ? (
						<strong>{data.scale}%</strong>
					) : (
						<Skeleton
							animated
							style={{
								height: pxToRem(40),
								width: "80%",
								margin: "0 auto",
							}}
						/>
					)}
				</div>
			</div>
			<div className="down">
				<div className="coin">
					<Image
						src={require("@/assets/images/icons/USDT.png")}
						width={28}
						height={28}
					/>
					{/* <span className="icon">C</span> */}
					<span className="name">USDT</span>
					<DownFill color="#5E71B7" fontSize={10} />
				</div>
				<Button
					onClick={() => ApplyProportionPopup.showPopup()}
					block
					shape="rounded"
					disabled={isAdminType}
					style={{
						width: pxToRem(144),
						height: pxToRem(40),
						fontSize: pxToRem(14),
						background:
							"linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
						"--text-color": "#FFFFFF",
						"--border-color": "#2F3A62",
					}}
				>
					{t("ManageVault")}
				</Button>
			</div>

			<ApplyProportionPopup.PopupComp
				visible={ApplyProportionPopup.visiblePopup}
				onClose={ApplyProportionPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ApplyProportionPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				{ApplyProportionPopup.visiblePopup && (
					<ApplyProportion
						onVisiblePopup={ApplyProportionPopup.closePopup}
						scale={data.scale}
					/>
				)}
			</ApplyProportionPopup.PopupComp>
		</div>
	);
};

export default VaultBalance;

const useStyles = createUseStyles({
	vaultBalance: {
		padding: {
			left: pxToRem(18),
			right: pxToRem(18),
			top: pxToRem(15),
			bottom: pxToRem(15),
		},
		marginBottom: pxToRem(10),
		"& .up": {
			display: "flex",
			paddingBottom: pxToRem(8),
			"& .vaultScale": {
				marginBottom: pxToRem(6),
				"& div": {
					color: "#868FA8",
					fontSize: pxToRem(14),
					fontWeight: "400",
					lineHeight: pxToRem(22),
				},
				"& strong": {
					color: "#FFFFFF",
					fontSize: pxToRem(26),
					fontWeight: "600",
					lineHeight: pxToRem(40),
				},
				"&:first-of-type": {
					position: "relative",
					flex: 1,
					overflow: "hidden",
					"&:after": {
						position: "absolute",
						content: '""',
						top: 0,
						right: 0,
						width: "1px",
						height: pxToRem(54),
						backgroundColor: "#2F3A62",
					},
				},
				"&:last-of-type": {
					width: pxToRem(100),
					textAlign: "center",
				},
			},
		},
		"& .down": {
			display: "flex",
			justifyContent: "space-between",
			"& .coin": {
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(8),
					right: pxToRem(16),
				},
				width: pxToRem(144),
				height: pxToRem(40),
				borderRadius: pxToRem(40),
				border: "1px solid #2F3A62",
				"& .icon": {
					width: pxToRem(28),
					height: pxToRem(28),
					lineHeight: pxToRem(28),
					textAlign: "center",
					borderRadius: "100%",
					fontSize: pxToRem(18),
					fontWeight: "400",
					color: "#84A2FF",
					backgroundColor: "#35486D",
				},
			},
			"& .name": {
				flex: 1,
				overflow: "hidden",
				padding: {
					left: pxToRem(8),
					right: pxToRem(8),
				},
				fontSize: pxToRem(14),
				fontWeight: "400",
				color: "#FFFFFF",
			},
		},
	},
});
